<template>
  <div class="container-fluid p-4">
    <h1 class="text-center fw-normal">Mesas</h1>
    <div id="categories-container" class="d-flex justify-content-center my-3">
      <div id="categories-nav" class="btn-group" role="group">
        <button class="btn rounded-4 mx-1 categories-btn" :class="{ active: filter === 'todos' }" @click="filterTables('todos')">Todos</button>
        <button class="btn rounded-4 mx-1 categories-btn" :class="{ active: filter === 'ocupada' }" @click="filterTables('ocupada')">Ocupada</button>
        <button class="btn rounded-4 mx-1 categories-btn" :class="{ active: filter === 'libre' }" @click="filterTables('libre')">Libre</button>
        <button class="btn rounded-4 mx-1 categories-btn" :class="{ active: filter === 'cuenta' }" @click="filterTables('cuenta')">Cuenta</button>
      </div>
    </div>
    <div class="row mb-1">
      <div class="row" style="width: 100vw !important;" v-if="this.filteredTables.length == 0">
        <div class="col-xl-4 col-lg-5 col-md-6 col-sm-8 col-11 mx-auto" v-html="not_plates_founds"></div>
        <h3 class="text-center mt-1">No hay mesas en este estado</h3>
      </div>
      <div v-for="table in filteredTables" :key="table.id" class="col-12 col-sm-6 col-lg-4 mb-4">
        <div class="card shadow-sm d-flex flex-column justify-content-between h-100">
          <span v-if="table.state === 'cuenta' || table.state === 'llamada'" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style="font-size: 1rem;">
            1
          </span>
          <div class="d-flex flex-column justify-content-between pt-3">
            <p class="card-title text-center mb-1 fw-bold fs-4">{{ table.number }}</p>
            <div v-if="table.is_delivery" class="d-flex justify-content-center">
                <span class="bg-primary rounded-5 px-2">delivery</span>
            </div>
            <div v-if="table.is_take_away" class="d-flex justify-content-center">
                <span class="bg-warning rounded-5 px-2">take away</span>
            </div>
            <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
              <div v-if="table.state === 'libre'" class="d-flex flex-column justify-content-center align-items-center py-2">
                <div class="d-flex justify-content-center align-items-center mb-2">
                  <p class="fw-bold mb-0 me-2 text-end" style="width: 120px;">Adultos:</p>
                  <div class="d-flex align-items-center">
                    <i class="fa-solid fa-minus botonCantidad py-1 me-2 px-1" @click="updateDinners(table, -1, true)"></i>
                    <span style="color: #19344F" :id="`${table.id}_adults`" class="fw-bold">{{ table.adults }}</span>
                    <i class="fa-solid fa-plus botonCantidad py-1 ms-2 px-1" @click="updateDinners(table, 1, true)"></i>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <p class="fw-bold mb-0 me-2 text-end" style="width: 120px;">Niños:</p>
                  <div class="d-flex align-items-center">
                    <i class="fa-solid fa-minus botonCantidad py-1 me-2 px-1" @click="updateDinners(table, -1, false)"></i>
                    <span style="color: #19344F" :id="`${table.id}_children`" class="fw-bold">{{ table.children }}</span>
                    <i class="fa-solid fa-plus botonCantidad py-1 ms-2 px-1" @click="updateDinners(table, 1, false)"></i>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-danger" style="font-size: 0.9rem;">Capacidad: {{ table.max_diners }} comensales</p>
              </div>
              <div v-else class="text-center mt-3 mb-1">
                <p class="fw-bold">Comensales: {{ table.actual_diners }}</p>
              </div>
            </div>
            <div class="text-center">
              <strong class="fs-4" :class="table.state === 'libre' ? 'text-success' : table.state === 'ocupada' ? 'text-danger' : table.state === 'cuenta' ? 'text-warning': 'text-info'">{{ table.state.toUpperCase() }}</strong>
            </div>
          </div>
          <div v-if="table.state != 'libre'">
            <p v-if="table.mode_name" class="text-center fw-semibold mb-0">Modo: {{ table.mode_name }}</p>
            <p v-else class="text-center fw-semibold mb-0">Modo: Normal</p>
          </div>
          <div class="card-footer bg-transparent  border-0  text-center mt-0 d-flex justify-content-center" :class="table.state === 'libre' ? 'pb-4' : 'pb-2'">
            <button v-if="table.state === 'libre'" class="btn btn-dark btn-sm w-50 rounded-2" :class="{ 'btn-disabled': hasTPV }" @click="onTPVAction(() => showActivateModal(table.id))">ACTIVAR</button>
            <button v-if="table.state === 'ocupada'" :class="{ 'btn-disabled': hasTPV }" class="btn btn-dark btn-sm w-50 rounded-2" @click="onTPVAction(() => unlockTable(table.id))">LIBERAR</button>
            <button v-if="table.state === 'cuenta'" :class="{ 'btn-disabled': hasTPV }" class="btn btn-dark btn-sm rounded-2" @click="onTPVAction(() => attendTable(table.id))">ATENDIDA</button>
            <button v-if="table.state === 'cuenta'" :class="{ 'btn-disabled': hasTPV }" class="btn btn-dark btn-sm rounded-2 ms-2" @click="onTPVAction(() => payedTable(table.id))">PAGADO</button>
            <button v-if="table.state === 'llamada'" :class="{ 'btn-disabled': hasTPV }" class="btn btn-dark btn-sm w-50 rounded-2" @click="onTPVAction(() => attendTable(table.id))">ATENDIDA</button>
            <!--<div v-if="table.state === 'cuenta'" class="d-flex justify-content-between px-3">
              <button class="btn btn-dark btn-sm w-50 mr-5 rounded-2" @click="attendTable(table.id)">ATENDIDA</button>
              <button class="btn btn-dark btn-sm w-50 rounded-2" @click="unlockTable(table.id)">LIBERAR</button>
            </div>-->
          </div>
          <div class="row m-0 pb-3 px-3">
            <div v-if="table.state != 'libre' && !table.is_delivery && !table.is_take_away" class=" d-flex flex-wrap px-3 mt-2" :class="print_tickets?'col-sm-6 col-12':'col-12'">
              <button v-if="table.unpaid==null" class="btn btn-success btn-sm flex-fill text-truncate rounded-2" @click="calculate_unpaid(table.id)">Calcular cuenta</button>
              <p v-else class="text-success fs-5 fw-bold flex-fill text-truncate text-center" @click="calculate_unpaid(table.id)">{{ table.unpaid.toFixed(2) }}€</p>
            </div>
            <div v-if="table.state != 'libre' && !table.is_delivery && !table.is_take_away && print_tickets" class="d-flex flex-wrap px-3 mt-2" :class="print_tickets?'col-sm-6 col-12':''">
              <button class="btn btn-success btn-sm flex-fill text-truncate rounded-2" @click="print_ticket(table.id)">Imprimir cuenta</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div v-if="showTPVAlert" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(139, 139, 139, 0.5); z-index: 1000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h5 class="mb-2">
          <i class="fa-solid fa-circle-xmark text-danger"></i>
          Acción no disponible
        </h5>
        <p class="mb-0">
          Al tener el TPV informado, no puedes activar o desactivar mesas desde la plataforma. Dirígete al TPV para realizar esta acción.
        </p>
      </div>
    </div>

    <!-- Desktop -->
    <div v-if="showTPVAlert" class="position-fixed top-0 start-0 w-100 h-100 d-none d-md-flex align-items-center justify-content-center" style="background-color: rgba(139, 139, 139, 0.5); z-index: 1000;">
      <div class="bg-white border shadow-lg p-4 rounded" style="max-width: 560px;">
        <h5 class="mb-2"> 
          <i class="fa-solid fa-circle-xmark text-danger"></i>
          Acción no disponible
        </h5>
        <p class="mb-0">Al tener el TPV informado, no puedes activar o desactivar mesas desde la plataforma. Dirígete al TPV para realizar esta acción.</p>
        <div class="text-end mt-3">
          <button class="btn text-white" style="background-color: var(--primary-color);" @click="showTPVAlert = false">Entendido</button>
        </div>
      </div>
    </div>

    <ActivateTableModalComponent
      :show-modal="showModal"
      :activate-table-id="activateTableId"
      :modes="modes"
      @close-modal="closeModal"
      @confirm-activation="activateTable"
    />
    <SpinnerComponent id="spinner" style="z-index: 1000;"></SpinnerComponent>
  </div>
</template>

<script>
  import ActivateTableModalComponent from '@/components/ActivateTableModalComponent.vue';
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import axios from 'axios';
  import { mapState } from 'vuex';
  
  import not_plates_founds from '@/assets/not_plates_founds.svg?raw';


  export default {
    components: {
      ActivateTableModalComponent,
      SpinnerComponent
    },
    data() {
      return {
        filter: "todos",
        showModal: false,
        activateTableId: null,
        tables: [],
        modes: [],
        first_charge: true,
        print_tickets: false,
        not_plates_founds,
        hasTPV: false,
        showTPVAlert: false,
        table_adults: 0,
        table_children: 0
      };
    },
    computed: {
      filteredTables() {
        const tablesCopy = [...this.tables]; // Crear una copia del array para no mutar el original
        if (this.filter === "todos") {
          return tablesCopy // Ordenar la copia
        }
        return tablesCopy
          .filter((table) => table.state === this.filter) // Filtrar la copia
      },
      ...mapState(['partner_token'])
    },
    methods: {
      filterTables(filter) {
        this.filter = filter;
      },
      async print_ticket(id){
        const table = this.tables.find((table) => table.id === id);
        if (table) {
          document.getElementById("spinner").classList.remove("d-none")
          let url = process.env.VUE_APP_API_URL+'/v1/api/app/printTicketTable?table_id='+id          
          try {
            await axios.post(url, {}, {
              headers: {
                'Authorization': `Bearer ${this.partner_token}`
              }
            });
            document.getElementById("spinner").classList.add("d-none")
          } catch (error) {
            console.error('Error fetching shopping cart:', error);
            document.getElementById("spinner").classList.add("d-none")
          }
        }
      },
      async unlockTable(id) {
        const table = this.tables.find((table) => table.id === id);
        if (table) {
          document.getElementById("spinner").classList.remove("d-none")
          let url = process.env.VUE_APP_API_URL+'/v1/api/app/desactiveTable?table_id='+id          
          try {
            const response = await axios.post(url, {}, {
              headers: {
                'Authorization': `Bearer ${this.partner_token}`
              }
            });
            console.log(response.data);
            table.state = 'libre'
            document.getElementById("spinner").classList.add("d-none")
          } catch (error) {
            console.error('Error fetching shopping cart:', error);
            document.getElementById("spinner").classList.add("d-none")
          }
        }
      },
      showActivateModal(id) {
        const table = this.tables.find((t) => t.id === id)
        if (table.adults <= 0) {
          document.getElementById(id+"_adults").classList.add('shake');
          setTimeout(() => {
            document.getElementById(id+"_adults").classList.remove('shake');
          }, 500);
          return
        }
        if (this.modes.length == 0) {
          this.activateTable({ id, mode: null })
          return
        }
        this.activateTableId = id
        this.showModal = true
      },
      closeModal() {
        this.showModal = false;
        this.activateTableId = null;
      },
      async activateTable({ id, mode }) {
        const table = this.tables.find((t) => t.id === id)
        const adults_int = table.adults
        const children_int = table.children

        document.getElementById("spinner").classList.remove("d-none")
        
        let url = process.env.VUE_APP_API_URL+'/v1/api/app/activeTable?table_id='+id
        if (mode) url += "&mode_id="+mode
        url += "&adults="+adults_int+"&children="+children_int;
        
        try {
          const response = await axios.post(url, {}, {
            headers: {
              'Authorization': `Bearer ${this.partner_token}`
            }
          });
          console.log(response.data);
          table.state = 'ocupada'
          this.first_charge = true
          this.fetchMesas()
          document.getElementById("spinner").classList.add("d-none")
        } catch (error) {
          document.getElementById("spinner").classList.add("d-none")
          console.error('Error fetching shopping cart:', error);
        }
        this.activateTableId = null;
        this.showModal = false;
      },
      async attendTable(id) {
        document.getElementById("spinner").classList.remove("d-none")
        const table = this.tables.find((table) => table.id === id);
        if (table) {
          let url = process.env.VUE_APP_API_URL+'/v1/api/app/attendTable?table_id='+id          
          try {
            const response = await axios.post(url, {}, {
              headers: {
                'Authorization': `Bearer ${this.partner_token}`
              }
            });
            console.log(response.data);
            table.state = 'ocupada'
            document.getElementById("spinner").classList.add("d-none")
          } catch (error) {
            document.getElementById("spinner").classList.add("d-none")
            console.error('Error fetching shopping cart:', error);
          }
        }
      },
      async payedTable(id) {
        document.getElementById("spinner").classList.remove("d-none")
        const table = this.tables.find((table) => table.id === id);
        if (table) {
          let url = process.env.VUE_APP_API_URL+'/v1/api/app/payedTable?table_id='+id          
          try {
            const response = await axios.post(url, {}, {
              headers: {
                'Authorization': `Bearer ${this.partner_token}`
              }
            });
            console.log(response.data);
            table.state = 'ocupada'
            document.getElementById("spinner").classList.add("d-none")
          } catch (error) {
            console.error('Error fetching shopping cart:', error);
            document.getElementById("spinner").classList.add("d-none")
          }
        }
      },
      updateDinners(table, incremento, is_adults) {
        if (is_adults) {
          table.adults = Math.max(0, table.adults + incremento)
        } else {
          table.children = Math.max(0, table.children + incremento)
        }
      },
      async calculate_unpaid(table_id){
        const table = this.tables.find((table) => table.id === table_id);

        if(table){
          if (this.first_charge && document.getElementById("spinner")){
            document.getElementById("spinner").classList.remove("d-none")
          }
          const token = this.partner_token; // Suponiendo que tienes el token almacenado en Vuex
          const url = process.env.VUE_APP_API_URL+'/v1/api/app/OrdersByTable?table_id='+table_id;
          try {
            const response = await axios.get(url, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            
            let orders = response.data.orders
            let mode = response.data.mode

            let total_price = 0

            orders.forEach(order=>{
              let min_state = null
              
              order.shopping_carts.forEach(shopping_cart=>{
                  let plate_structure = {}
                  plate_structure.id = shopping_cart.id
                  plate_structure.price = shopping_cart.unit_price
                  const stepSupplements = shopping_cart.steps_selected.reduce((sum, step) => {
                    return sum + parseFloat(step.plate?.supplement || 0);
                  }, 0);
                  plate_structure.price +=  stepSupplements
                  plate_structure.amount = shopping_cart.amount
                  
                  if (mode && plate_structure.category && !mode.excluded_categories.some(cat => cat.id === plate_structure.category.id)){
                      plate_structure.price *= (100 - mode.discount) / 100
                      plate_structure.price = Math.round(plate_structure.price * 100) / 100;
                  }

                  if (mode && !plate_structure.category){
                    if(plate_structure.plate_id == 'd368dc34-ca2a-4976-8834-9e5dd6e28e25'){
                      plate_structure.price = mode.adult_price
                    }else if(plate_structure.plate_id == 'ad9e80c6-fd8d-4d42-8227-89155ab7c210'){
                      plate_structure.price = mode.children_price
                    }
                  }

                  // Ordenos los estados de cada plato de mayor a menor
                  shopping_cart.state_orders = shopping_cart.state_orders.sort((a, b) => {
                      return new Date(b.created_at)- new Date(a.created_at);
                  });

                  plate_structure.state = shopping_cart.state_orders[0].state

                  plate_structure.state = plate_structure.state.name
                  
                  if (min_state == null || min_state[0] > plate_structure.state.sort){
                      min_state = [plate_structure.state.sort, plate_structure.state.name]
                  }
                  console.log("ESTADOO: " + plate_structure.state)
                  if (plate_structure.state != "PAGADO" && plate_structure.state != "CANCELADO" && plate_structure.state != "CANCELADO POR CLIENTE"){
                    total_price+=plate_structure.price * plate_structure.amount
                  }                
              })
            })

            table.unpaid = total_price
            
            if (document.getElementById("spinner")){
                document.getElementById("spinner").classList.add("d-none")
            }

          } catch (error) {
            // Maneja el error
            if (document.getElementById("spinner")){
                document.getElementById("spinner").classList.add("d-none")
            }
            console.error('Error fetching tables:', error);
          }
        }
        
      },
      onTPVAction(fn) {
        if (this.hasTPV) {
          this.showTPVAlert = true;
          setTimeout(() => {
              this.showTPVAlert = false;
          }, 3000);
          return;
        }

        if (typeof fn === 'function') fn();
      },
      async fetchMesas() {
        if (this.first_charge && document.getElementById("spinner")){
            document.getElementById("spinner").classList.remove("d-none")
        }
        const token = this.partner_token; // Suponiendo que tienes el token almacenado en Vuex
        const url = process.env.VUE_APP_API_URL+'/v1/api/app/PanelTables';
        try {
          const response = await axios.get(url, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          // Maneja la respuesta
          this.print_tickets = response.data.print_tickets
          console.log(response.data);
          this.tables = response.data.tables.filter(table => table.active)
          this.modes = response.data.modes
          this.hasTPV = response.data.hasTPV
          console.log(this.tables)
          this.tables.forEach(table => {
              table.actual_diners = Number(table.actual_diners) + Number(table.actual_children)
              table.adults = 0
              table.children = 0
              if(table.mode != null){
                table.mode_name = table.mode.name
              }
              if(table.start_time == null){
                table.state = 'libre'
              }else if (table.ordered_bill){
                table.state = 'cuenta'
              }else if(table.waiter_call){
                table.state = 'llamada'
              }else{
                table.state = 'ocupada'
              }
          })

          if(this.first_charge){
            if (document.getElementById("spinner")){
                document.getElementById("spinner").classList.add("d-none")
            }
            this.first_charge=false
          }
          this.tables = this.tables.sort((a, b) => {
              return a.number.localeCompare(b.number);
          });
        } catch (error) {
          // Maneja el error
          this.tables = []
          if (document.getElementById("spinner")){
              document.getElementById("spinner").classList.add("d-none")
          }
          console.error('Error fetching tables:', error);
        }
      },
      startPolling() {
          this.fetchMesas();
          this.pollingInterval = setInterval(this.fetchMesas, 15000); // Cada 5 segundos
      },
      stopPolling() {
        clearInterval(this.pollingInterval);
      },
    },
    created() {
      this.startPolling();
    },
    beforeUnmount() {
      this.stopPolling();
    }
  };
</script>

<style scoped>
  .categories-btn{
    background-color: #f1f5f5;
  }

  .card-title {
    font-size: 1.25rem;
    word-wrap: break-word;
  }

  .card {
    height: 100%;
  }

  .card-footer {
    margin-top: auto;
  }

  .btn-group .btn.active {
    background-color: var(--primary-color);
    color: white;
  }

  .btn {
    white-space: nowrap;
  }

  .custom-btn:focus, 
  .custom-btn:active, 
  .custom-btn:hover {
    background-color: transparent;
    border-color: var(--primary-color);
    color: var(--primary-color);
    box-shadow: none;
  }

  .btn-disabled {
    opacity: 0.5;
    pointer-events: auto;
    cursor: not-allowed;
  }

  @media (max-width: 576px) {
    .btn {
      font-size: 0.9rem;
      padding: 0.25rem 0.5rem;
    }

    .card-title {
      font-size: 1rem;
    }
  }
</style>